import React, { useState } from "react";
import "./Benefits.css";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // styles for the picker

const sampleData = {
  SSS: [
    {
      date: "January 1, 2025 - January 15, 2025",
      employer: 900,
      employee: 300,
    },
    {
      date: "January 16, 2025 - January 31, 2025",
      employer: 900,
      employee: 300,
    },
    {
      date: "March 1, 2025 - March 15, 2025",
      employer: 900,
      employee: 300,
    },
    {
      date: "April 16, 2025 - April 31, 2025",
      employer: 900,
      employee: 300,
    },
    {
      date: "May 1, 2025 - May 15, 2025",
      employer: 900,
      employee: 300,
    },
    {
      date: "June 16, 2025 - June 31, 2025",
      employer: 900,
      employee: 300,
    },
  ],
  PhilHealth: [
    {
      date: "January 1, 2025 - January 15, 2025",
      employer: 500,
      employee: 500,
    },
    {
      date: "January 16, 2025 - January 31, 2025",
      employer: 500,
      employee: 500,
    },
  ],
  PagIbig: [
    {
      date: "January 1, 2025 - January 15, 2025",
      employer: 100,
      employee: 100,
    },
    {
      date: "January 16, 2025 - January 31, 2025",
      employer: 100,
      employee: 100,
    },
  ],
};

export default function Benefits() {
  const [selectedBenefit, setSelectedBenefit] = useState("SSS");
  const [startDate, setStartDate] = useState(new Date(2025, 1, 1)); // Feb 1, 2025
  const [endDate, setEndDate] = useState(new Date(2025, 1, 28)); // Feb 28, 2025

  const contributions = sampleData[selectedBenefit];

  return (
    <div className="benefits-page">
      <Header />
      <SubHeader />
      <div className="benefits-container">

        <h2 className="benefits-header-row">
          <span className="benefits-header">
            BENEFITS &gt; {selectedBenefit}
          </span>
          <div className="filters">

            <div className="filter-item">
              <label className="filter-label">Date:</label>
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(dates) => {
                  const [start, end] = dates;
                  setStartDate(start);
                  setEndDate(end);
                }}
                dateFormat="MMMM d, yyyy"
                className="filter-input"
                placeholderText="Select date range"
              />
            </div>

            <div className="filter-item">
              <label className="filter-label">Other benefit:</label>
              <select
                value={selectedBenefit}
                onChange={(e) => setSelectedBenefit(e.target.value)}
                className="filter-select"
              >
                <option value="SSS">SSS</option>
                <option value="PhilHealth">PhilHealth</option>
                <option value="PagIbig">Pag-IBIG</option>
              </select>
            </div>
          </div>
        </h2>


        <div className="table-wrapper">
          <table className="contribution-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Employer Share</th>
                <th>Employee Share</th>
                <th>Total Contribution</th>
              </tr>
            </thead>
            <tbody>
              {contributions.map((c, i) => (
                <tr key={i}>
                  <td>{c.date}</td>
                  <td>Php {c.employer.toFixed(2)}</td>
                  <td>Php {c.employee.toFixed(2)}</td>
                  <td className="total">
                    Php {(c.employer + c.employee).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
